import { render, staticRenderFns } from "./BaseDesc.vue?vue&type=template&id=2df27966&scoped=true"
import script from "./BaseDesc.vue?vue&type=script&lang=js"
export * from "./BaseDesc.vue?vue&type=script&lang=js"
import style0 from "./BaseDesc.vue?vue&type=style&index=0&id=2df27966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df27966",
  null
  
)

export default component.exports